<template lang="pug">
div
  PromosHeader
  main.promo
    .promo__content
      .head__bg
        img(:src="frontend_settings.bg_image")
      PromoHead(:promoIsActive="promo_is_active" :frontendSettings="frontend_settings")
      PromoContent(:promoIsActive="promo_is_active" :frontendSettings="frontend_settings" :challengesList="challenges_list" :offersList="offers_list")
  PromosFooter
  Registration(:showHeading="false")
  DownloadPopup
</template>

<script>
import Registration from "@chronos/frontend-base/src/components/register/mygames/ProjectReg";
import PromosFooter from "@static_promo_pages/common/components/footer/vue/PromosFooter";
import PromosHeader from "@static_promo_pages/common/components/header/vue/PromosHeader";
import DownloadPopup from "@battle_teams_2_components/components/popups/vue/DownloadPopup";
import UserMixin from "@chronos/frontend-base/src/mixins/user/UserMixin.js";
import MobileDetectionMixin from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixinNew";
import PromoHead from "./blocks/PromoHead";
import PromoContent from "./blocks/PromoContent";
import ObjectCheckMixin from "@/assets/js/ObjectCheckMixin.js";

export default {
  name: "Promo",

  components: {
    Registration,
    PromosFooter,
    PromosHeader,
    DownloadPopup,
    PromoHead,
    PromoContent,
  },

  mixins: [UserMixin, MobileDetectionMixin, ObjectCheckMixin],

  data() {
    return {
      promo_name: "event",
      gem_loaded: false,
      promo_state: false,
      challenges_list: [],
      offers_list: {},
      frontend_settings: {},
    };
  },
  computed: {
    autoDownloadGC() {
      return this.$store.state.global?.show_after_reg_popup;
    },
  },

  created() {
    document.addEventListener("init_vue_components", () => {
      this.initPromo();
    });

    document.addEventListener("GEM_loaded", () => {
      this.gem_loaded = true;
    });
  },
  mounted() {
    this.getUniversalPromoChallenges();
    this.getActivityInfo();
  },

  methods: {
    async initPromo() {
      await this.$store.dispatch("global/auth", { profile_fields: ["registration_url"] });
      if (this.autoDownloadGC) {
        if (this.gem_loaded) {
          this.gameDownload("", true, true)
        } else {
          document.addEventListener("GEM_loaded", () => { this.gameDownload("", true, true) })
        }
      }
    },
    getActivityInfo() {
      this.$api.minigamesService
        .getActivityByKey("universal-promo")
        .run()
        .then(response => {
          if (this.$api.isApiResponseError(response)) {
            throw this.$api.getApiResponseError(response);
          } else {
            this.frontend_settings = response.data.result.frontend_settings;
          }
        });
    },
    getUniversalPromoChallenges() {
      this.$api.universalPromoService
        .getInfo("universal-promo")
        .run()
        .then(response => {
          if (this.$api.isApiResponseError(response)) {
            throw this.$api.getApiResponseError(response);
          } else {
            this.challenges_list = response.data.result.quests;
            this.promo_is_active = response.data.result.is_active;
            this.getOffersList();
          }
        });
    },
    getOffersList() {
      let offers = [];
      this.challenges_list.forEach((el) => {
        if (this.isObject(el.rewards)) {
          const keys = Object.keys(el.rewards);
          offers.push(...keys);
        }
      });
      offers = Array.from(new Set(offers));

      this.$api.storeService
        .getOffersExtended({ names: offers })
        .run()
        .then(response => {
          if (this.$api.isApiResponseError(response)) {
            throw this.$api.getApiResponseError(response);
          } else {
            const offersList = {}

            response.data.result.data.forEach((el) => {
              offersList[el.name] = {
                image: el.images.main,
                name: el.title.ru,
              };
            })

            this.offers_list = offersList;
          }
        });
    },
  },
};
</script>
